<template>

	<div class="box size30">
		<h2>Three-Sixty Media bvba</h2>
		<p>Meiselaan 74, 1880 Nieuwenrode</p>
		<p>+32 (0) 15 63 51 43<br>
			<a href="mailto:info@three-sixty.be?subject=Contact from CMS">info@three-sixty.be</a>
		</p>
		<p>BE 0897.382.632<br>IBAN BE 12 0015 5139 8192<br></p>
		<p>BIC GEBABEBB</p>
	</div>

</template>

<script>

export default {
	name: 'contact',
	props: ['contactdata']
}

</script>
